import {Router} from "../../../stem-core/ui/Router.jsx";
import {INLINE_USER_DASHBOARD_URLS} from "../PanelConstants.js";
import {BaseFlowHandler} from "./BaseFlowHandler.js";
import {PANEL_TYPE} from "../../../blink-sdk/Constants.js";
import {Flow} from "./Flow.js";
import {iFrameState} from "../../services/IFrameState.js";
import {toArray, unwrapArray} from "../../../stem-core/base/Utils.js";
import {iFrameMerchantService} from "../../services/IframeMerchantService.js";
import type {PaymentMethod} from "../../../client/state/PaymentMethodStore";


export class DashboardFlowHandler extends BaseFlowHandler {
    panelType = PANEL_TYPE.dashboard;
    // The card the account tab picked for removal, read back by UserDashboardRemoveCardPanel
    declare card?: PaymentMethod;

    getFlowPlan() {
        return [Flow.auth];
    }

    getDashboardTabTypes() {
        const {dashboardTabs} = iFrameState.iframeParams;

        if (dashboardTabs) {
            return toArray(dashboardTabs);
        }

        const merchant = iFrameMerchantService.getMerchant();

        return unwrapArray([
            merchant.allowSubscriptions && PANEL_TYPE.subscribe,
            merchant.allowDonations && PANEL_TYPE.donation,
            merchant.allowEmailing && PANEL_TYPE.newsletter,
            PANEL_TYPE.auth,
        ]);
    }

    finalize() {
        Router.changeURL(INLINE_USER_DASHBOARD_URLS.home);
    }
}
